import { isLocal } from '@lcsc-ui/utils/baseUrl';
import { doGet, doPost } from '@lcsc-ui/utils/request';

// client请求接口
let domain = 'lcscOverseaUrl';
if (isLocal) {
  domain = 'https://devoverseas.szlcsc.com';
}
// 查找更多渠道
export function searchMoreChannel({ from, paramJson, index }) {
  const fd = new FormData();
  fd.append('paramJson', JSON.stringify(paramJson));
  let url = '/overseas/search/more/channel';
  if (isLocal) {
    url = `/overseas/search/more/channel${index}`;
  }
  return doPost(domain, `${url}?from=${from}`, fd);
}
// 供应商别名
export function searchAlias() {
  return doGet(domain, '/overseas/search/alias');
}
// 供应商列表
export function searchProviders() {
  return doGet(domain, '/overseas/search/providers');
}
// 海外代购搜索
export function overseasSearch(query) {
  return doGet(domain, `/overseas/search/${query.providers}`, query);
}
// 立创订货
export function overseasGlobalSearch(query) {
  return doGet(domain, `/overseas/global/search`, query);
}
// 更多海外代购
export function overseasGlobalSearchProvider(query) {
  return doGet(domain, `/overseas/global/search/${query.providers}`, query);
}
